import cn from 'classnames';
import { forwardRef } from 'react';

export interface RadioGroupInputProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  name?: string;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'secondary' | 'white';
  isSolid?: boolean;
  className?: string;
}

export const RadioGroupInput = forwardRef<HTMLInputElement, RadioGroupInputProps>(
  ({ checked, onChange, disabled, name, label, size = 'md', color = 'primary', isSolid = true, className }, ref) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(event.target.checked);
      }
    };

    const wrapperClasses = cn('form-check', 'form-check-custom', {
      'form-check-solid': isSolid,
      'form-check-sm': size === 'sm',
      'form-check-lg': size === 'lg',
      'form-check-primary': color === 'primary',
      'form-check-secondary': color === 'secondary',
      'form-check-white': color === 'white'
    });

    return (
      <div className={cn(wrapperClasses, className)}>
        <input
          ref={ref}
          type="radio"
          className="form-check-input"
          name={name}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
        />
        {label && <label className="form-check-label">{label}</label>}
      </div>
    );
  }
);

RadioGroupInput.displayName = 'RadioGroupInput';
